const OBJECTTYPES = {
  PARKINGS: 'parkings',
  PARKOMATS: 'parcomats',
  TERMINALS: 'terminals',
  INFORMATIONTABLE: 'InformationTable'
};

export default OBJECTTYPES;
